const sliderPagination = () => {
  setInterval(() => {
    // Move Slider Pagination for Every Slider
    const sliders = document.querySelectorAll(".slideshow");
    if (sliders) {
      const paginationCheck = document.querySelector(".pagination-check");
      if (!paginationCheck) {
        sliders.forEach((slider) => {
          const pagination = slider.querySelector(".swiper-pagination"),
            dots = pagination.querySelectorAll(".swiper-pagination-bullet");
          moveSliderPagination(pagination, dots);
          pagination.classList.add("pagination-check");
        });
      }
    }
  }, 100);
};

export default sliderPagination;

/**
 * Move Slider Pagination
 *
 * @param html pagination
 * @param html dots
 */

const moveSliderPagination = (pagination, dots) => {
  if (pagination && dots) {
    const container = document.createElement("div");
    container.classList.add("container");
    dots.forEach((dot) => {
      container.appendChild(dot);
    });
    pagination.appendChild(container);
  } else {
    console.log("Missing params in function moveSliderPagination(pagination, dots)", [pagination, dots]);
  }
}
